"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.continuationForPlace = exports.hasMoreForPlace = exports.continuationFollowed = exports.hasMoreFollowed = exports.continuation = exports.hasMoreItems = exports.entities = void 0;

var _redux = require("redux");

var _lodash = require("lodash");

var _actionTypes = require("./actionTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
state.collections: {
    123123: {
        events: [12,3,4,5],
        name: Cool Collection,
        secret: 234234,
        id: 123123,
    },
    123124: {
        events: [12,3,4,5],
        name: Cool Collection,
        secret: 234234,
        id: 123123,
    }
}
*/
var entities = function entities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  var nextState = state;

  if (type === _actionTypes.CLEAR_COLLECTIONS) {
    nextState = {};
  }

  if (type === _actionTypes.SET_COLLECTIONS) {
    nextState = _objectSpread(_objectSpread({}, nextState), payload.entities);
  }

  if (type === _actionTypes.UPDATE_COLLECTION) {
    nextState = _objectSpread(_objectSpread({}, nextState), {}, _defineProperty({}, payload.id, _objectSpread(_objectSpread({}, nextState[payload.id]), payload)));
  }

  if (type === _actionTypes.UPDATE_COLLECTION_EVENTS) {
    nextState = _objectSpread(_objectSpread({}, nextState), {}, _defineProperty({}, payload.collectionId, _objectSpread(_objectSpread({}, nextState[payload.collectionId]), {}, {
      eventCount: payload.shouldAdd ? nextState[payload.collectionId].eventCount += 1 : nextState[payload.collectionId].eventCount -= 1
    })));
  }

  if (type === _actionTypes.DELETE_COLLECTION) {
    nextState = (0, _lodash.omit)(nextState, payload);
  }

  return nextState;
};

exports.entities = entities;

var hasMoreItems = function hasMoreItems() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref2.type,
      payload = _ref2.payload;

  var nextState = state;

  if (type === _actionTypes.SET_COLLECTIONS && payload.hasMoreItems) {
    nextState = payload.hasMoreItems;
  }

  return nextState;
};

exports.hasMoreItems = hasMoreItems;

var continuation = function continuation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref3.type,
      payload = _ref3.payload;

  var nextState = state;

  if (type === _actionTypes.SET_COLLECTIONS && payload.continuation) {
    nextState = payload.continuation;
  }

  return nextState;
};

exports.continuation = continuation;

var hasMoreFollowed = function hasMoreFollowed() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref4 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref4.type,
      payload = _ref4.payload;

  var nextState = state;

  if (type === _actionTypes.SET_COLLECTIONS && 'hasMoreFollowed' in payload) {
    nextState = payload.hasMoreFollowed;
  }

  return nextState;
};

exports.hasMoreFollowed = hasMoreFollowed;

var continuationFollowed = function continuationFollowed() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref5 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref5.type,
      payload = _ref5.payload;

  var nextState = state;

  if (type === _actionTypes.SET_COLLECTIONS && payload.continuationFollowed) {
    nextState = payload.continuationFollowed;
  }

  return nextState;
};

exports.continuationFollowed = continuationFollowed;

var hasMoreForPlace = function hasMoreForPlace() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref6 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref6.type,
      payload = _ref6.payload;

  var nextState = state;

  if (type === _actionTypes.SET_COLLECTIONS && 'hasMoreForPlace' in payload) {
    nextState = payload.hasMoreForPlace;
  }

  return nextState;
};

exports.hasMoreForPlace = hasMoreForPlace;

var continuationForPlace = function continuationForPlace() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref7 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref7.type,
      payload = _ref7.payload;

  var nextState = state;

  if (type === _actionTypes.SET_COLLECTIONS && payload.continuationForPlace) {
    nextState = payload.continuationForPlace;
  }

  return nextState;
};

exports.continuationForPlace = continuationForPlace;

var _default = (0, _redux.combineReducers)({
  entities: entities,
  hasMoreItems: hasMoreItems,
  continuation: continuation,
  hasMoreFollowed: hasMoreFollowed,
  continuationFollowed: continuationFollowed,
  hasMoreForPlace: hasMoreForPlace,
  continuationForPlace: continuationForPlace
});

exports.default = _default;
//# sourceMappingURL=reducer.js.map